export const MESSAGE_CONFIG = {
    TYPES: {
        MESSAGE_TYPE_TEXT: 30,
        MESSAGE_TYPE_TEXT_OTHER: 31,
        MESSAGE_TYPE_IMAGE: 32,
        MESSAGE_TYPE_IMAGE_OTHER: 33,
        MESSAGE_TYPE_VIDEO: 34,
        MESSAGE_TYPE_DOC: 40,
        MESSAGE_TYPE_VIDEO_OTHER: 35,
        MESSAGE_TYPE_VOICE: 36,
        MESSAGE_TYPE_VOICE_OTHER: 37,
        MESSAGE_TYPE_RICH_TEXT: 50,
        MESSAGE_TYPE_RICH_TEXT_OTHER: 51,
        MESSAGE_TYPE_LOCATION: 70,
        MESSAGE_TYPE_CONTACT: 80,
        MESSAGE_TYPE_CONTACT_OTHER: 81,
        MESSAGE_TYPE_LOCATION_OTHER: 71,
        MESSAGE_TYPE_POST_SHARE: 90,
        MESSAGE_TYPE_POST_SHARE_OTHER: 91,
    },
    SUB_TYPES: {
        TEXT_FROM_NORMAL: 300,
        TEXT_FROM_QUICK: 302,
        TEXT_FROM_SIMILAR: 303,
        IMAGE_FROM_NORMAL: 320,
        DOC_FROM_NORMAL: 400,
        VIDEO_FROM_NORMAL: 340,
        AUDIO_FROM_NORMAL: 360,
        AUDIO_FROM_LISTING: 361,
        TEXT_FROM_FAV: 500,
        TEXT_FROM_CALL: 501,
        TEXT_ASK_FOR_PRICE: 502,
        TEXT_DROP_PRICE_NOTIFY: 503,
        TEXT_SEND_SIMILAR_ADS: 303,
        TEXT_ASK_FOR_IMAGE: 504,
        TEXT_ASK_FOR_MAP: 506,
        TEXT_APPLY_JOB: 508,
        TEXT_LOCATION: 700,
        TEXT_CONTACT: 800,
        TEXT_POST: 900
    }
};
